import { post } from "../../config/api";

class OffersService {
	static async uploadOffersCsv(formData) {
		const url = `/v1/billing/offer/csv/upload`;
		const headers = { accept: "multipart/form-data" };
		return await post({ url, data: formData, headers });
	}
}

export default OffersService;

